<template>
  <div class="page-header header-filter" style="background-image: url('img/bg32.jpg')">
    <!-- <div class="page-header-image"
             style="background-image: url('img/login.jpg')">
    </div>-->
    <form @submit="handleSubmit" class="content">
    <!-- <div class="content"> -->
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto">
          <card type="login" plain>
            <div slot="header" class="mr-auto">
              <!-- <img v-lazy="'img/now-logo.png'" alt=""> -->
              <h1 class="title">{{ constants.appTitle }}</h1>
            </div>

            <fg-input
              v-model="form.userName"
              class="no-border input-lg"
              addon-left-icon="now-ui-icons users_circle-08"
              placeholder="Nombre de usuario"
            ></fg-input>

            <fg-input
              type="password"
              v-model="form.password"
              class="no-border input-lg"
              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
              placeholder="Contraseña"
            ></fg-input>

            <template slot="raw-content">
              <div class="card-footer text-center">
                <button
                  type="submit"
                  class="btn btn-primary btn-round btn-lg btn-block"
                >Ingresar</button>
              </div>
              <div class="pull-left">
                <!-- <h6>
                  <a href="#pablo" class="link footer-link">Crear Cuenta</a>
                </h6>-->
              </div>
              <div class="pull-right">
                <h6>
                  <a href="#/prestador/reset" class="link footer-link">¿Olvidaste la contraseña?</a>
                </h6>
              </div>
            </template>
          </card>
        </div>
      </div>
    <!-- </div> -->
    </form>
    <!-- <main-footer></main-footer> -->
  </div>
</template>
<script>
import { Card, Button, FormGroupInput } from "@/components";
import { Select, Option } from "element-ui";
import * as authService from "../../services/AuthService";
//   import MainFooter from '@/layout/MainFooter';
export default {
  name: "login-page",
  bodyClass: "login-page",
  components: {
    Card,
    //   MainFooter,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      form: {
        firstName: "",
        email: "",
        phone: "",
        userName: "",
        password: ""
      }
    };
  },
  methods: {
    handleSubmit: function(event) {
      console.log('entrando...');
      event.preventDefault();

      let self=this;

      if (self.form.userName==='' || self.form.userName==null){
        self.$noty.error('El nombre de usuario es obligatorio');
        return;
      }

      if (self.form.password==='' || self.form.password==null){
        self.$noty.error('La contraseña es obligatoria');
        return;
      }
      authService.loginPrestador(
        this.form.userName,
        this.form.password,
        success => {},
        error => this.$noty.error(error)
      );
    }
  }
};
</script>
<style scoped>
</style>
